module.exports = __webpack_public_path__ + "static/img/10.adbca8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/eng/10.png
// module id = XnCw
// module chunks = 0